"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pipe = void 0;

/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity, the remaining functions must be unary.
 *
 * @param {Function}   first  First function in transform chain
 * @param {Function[]} rest   Remaining functions
 * @param {Array}      source First function arguments
 *
 * @return {Any}
 *
 * @name pipe
 * @tag Core
 * @signature (...fn: Fn[]) => (...source: Array): Any
 *
 * @example
 * pipe(inc, inc)(2)
 * // => 4
 */
var pipe = function pipe(first) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, source = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      source[_key2] = arguments[_key2];
    }

    var acc = first.apply(void 0, source);

    for (var i = 0, length = rest.length; i < length; i++) {
      acc = rest[i](acc, source[i], i, source);
    }

    return acc;
  };
};

exports.pipe = pipe;